<template>
  <div class="col-12 c g">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0"><i class="fa fa-envelope-open-o"></i> التعاميم</h4>
      </div>
      <div class="card-body">
        <p v-if="!loading && !mails.length" class="text-muted text-center mb-0">لا توجد تعاميم.</p>
        <div class="list">
          <a v-for="h in mails" :key="h._id" class="item" :href="`https://s.tahdir.net/mail/${h._id}/${h.teacher_id}`" target="_blank">
            <div class="main">
              <strong>{{ h.title }}</strong>
              <small class="text-muted d-block num">{{ h.date }}</small>
              <small v-if="h.reply" class="reply d-block">ردك: {{ h.reply }}</small>
            </div>
            <div class="states">
              <span v-if="h.signed_at" class="badge bg-success"><i class="fa fa-check"></i> وقّعت</span>
              <span v-if="h.reply" class="badge bg-info">تم الرد</span>
              <span v-if="!h.signed_at && !h.reply" class="badge bg-warning">بانتظار ردك</span>
              <span class="open">{{ h.signed_at || h.reply ? 'عرض' : 'فتح والتوقيع' }} <i class="fa fa-angle-left"></i></span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teacher: JSON.parse(localStorage.getItem('teacher')),
      mails: [],
      loading: true,
    };
  },
  created() {
    var g = this;
    $.post(api + '/teacher/mails2', {
      username: this.teacher.username,
      password: this.teacher.password,
    }).then(function(r){
      g.loading = false;
      if(r.status != 100) return alert(r.response);
      g.mails = r.response;
    }).fail(function(){ g.loading = false; });
  },
};
</script>

<style scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 12px;
  color: inherit;
}
.item:hover {
  background: var(--sk-soft, #F6F7FB);
  text-decoration: none;
}
.main {
  flex: 1;
  min-width: 0;
}
.reply {
  color: var(--sk-text, #344054);
  white-space: pre-line;
  margin-top: 2px;
}
.states {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}
.open {
  color: var(--sk-p, #1D4ED8);
  font-weight: 700;
  white-space: nowrap;
}
.num {
  font-variant-numeric: tabular-nums;
}
</style>
